import React, { PureComponent } from 'react'
import {
    LogoWrapper,
    CasImag,
    IecasImag,
    IcdImag,
    LastImag
} from '../Footer/style'

class Footer extends PureComponent {
    componentWillMount() {
        // var qid = document.location.href
        // debugger
    }

    render() {
        return (
            <LogoWrapper 
            // style={{display:document.location.href.indexOf('geovis')!=-1?'none':'block'}}
            >
                <div style={{ width: '85%', margin: '0px auto', height: '100%',textAlign:'center' }}>
                        <CasImag href='http://www.cas.cn/' target='_blank' />
                        <IecasImag href='http://www.aircas.ac.cn//' target='_blank' />
                        <IcdImag href='http://www.eq-icd.cn/' target='_blank' />
                        <LastImag href='http://www.sasmac.cn/' target='_blank' />
                </div>
            </LogoWrapper>
        )
    }
}

export default Footer;